module.exports = __webpack_public_path__ + "img/e1e8263cdfb22790d1de954204250cec.svg";